module.exports = __webpack_public_path__ + "img/wait.ee152423.gif";